import React from 'react';
import { AiOutlinePlusCircle } from 'react-icons/ai';

import Button from 'legacy/common/components/button/Button';

const DiscountCodeEmptyState = ({ handleAddDiscountCode }) => (
  <div
    data-testId="discount-code-empty-container"
    className="py-4 md:w-[420px] mx-auto"
  >
    <div className="pb-10">
      <div className="flex items-center justify-center px-10">
        <img src="/img/events/discount-codes-empty.png" className="w-32" />
        <p className="text-xl md:text-2xl text-primary-500">
          Boost sales with special discounts!
        </p>
      </div>
      <p className="md:mt-4 px-2 text-sm md:text-base text-primary-500 font-normal text-center">
        Discount codes reward loyal guests and fill out your crowd. You can add
        as many as you like, set usage limits, and pause them when needed to
        manage demand.
      </p>
    </div>
    <div>
      <Button onClick={handleAddDiscountCode}>
        <div className="flex items-center justify-center">
          <AiOutlinePlusCircle className="mr-2" /> Add Discount Code
        </div>
      </Button>
    </div>
  </div>
);

export default DiscountCodeEmptyState;
